import $ from "jquery";

console.log('landing...')

function isNullOrUndef(value){
    let isNull = null === value
    let isUndefined = undefined === value
    let isUndefinedStr = 'undefined' === value
    let isNullStr = 'null' === value
    let isUndNullStr  = 'Undefined or Null' === value
    let undefOrNull = isNull || isUndefined || isUndefinedStr || isNullStr || isUndNullStr
    // if(undefOrNull) {
    //     cyellow({'isNull': isNull,'isUndefined': isUndefined,'isUndefinedStr': isUndefinedStr,'isNullStr': isNullStr,'isUndNullStr':isUndNullStr})
    // }
    return undefOrNull
}
function checkVehicleSearch(setVehicle = false) {
    // These hidden fields hold the values to re-select after a form error.
    const yearId = $('#vehicle_years_id').val();
    const makeId = $('#make_id').val();
    const modelId = $('#model_id').val();
    const engineId = $('#engine_id').val();
    // Check if there's a year selected to start the process
    if (yearId) {
        getVehicleMakes()
            .then(function() {
                return getVehicleModels(); // Return the promise to continue the chain
            })
            .then(function() {
                return getVehicleEngines(setVehicle); // Return the promise
            })
    }
}

function getVehicleMakes() {
    $('#vehicle_models_id').empty().append(new Option('Seleccionar modelo', ''));
    $('#vehicle_engines_id').empty().append(new Option('Seleccionar motor', ''));
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/landing/makes/'+$('#vehicle_years_id').val()
    return getVehicles('makes', 'vehicle_years_id', 'vehicle_makes_id', path, 'Seleccionar marca', $('#make_id').val())
}

function getVehicleModels() {
    $('#vehicle_engines_id').empty().append(new Option('Seleccionar motor', ''));
    document.getElementById('bci-recomendado').innerHTML = ''
    let path = '/landing/models/'+$('#vehicle_years_id').val()+'/'+$('#vehicle_makes_id').val()
    return getVehicles('models', 'vehicle_makes_id', 'vehicle_models_id', path, 'Seleccionar modelo', $('#model_id').val())
}

function getVehicleEngines(setVehicle = false, option_txt) {
    let child = 'vehicle_engines_id'
    let target_val   = $('#vehicle_models_id').val()
    $('#'+child).empty().append(new Option('Seleccionar motor', ''));
    if (!target_val) {
        return $.Deferred().resolve().promise();
    }
    let path = '/landing/engines/'+$('#vehicle_years_id').val()+'/'+$('#vehicle_makes_id').val()+'/'+$('#vehicle_models_id').val()
    let selectId = $('#engine_id').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data['engines'].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                })
                $('#data_products').val(JSON.stringify(data['products']))
                if(selectId && setVehicle) {
                    $('#'+child).val(selectId).trigger('change');
                    setVehicleProduct()
                }
            } else {
                console.error('Something goes wrong while getting engines')
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}
function getVehicles(name, target, child, path, opt, selectId = null) {
    let target_val   = $('#'+target).val()
    $('#'+child).empty().append(new Option(opt, ''));
    if (!target_val) {
        // Return a resolved promise so the .then() chain doesn't break
        return $.Deferred().resolve().promise();
    }
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                data[name].forEach(item => {
                    $('#'+child).append(new Option(item.name, item.id));
                });
                if(selectId) {
                    $('#'+child).val(selectId).trigger('change');
                }
            } else {
                console.error('Something goes wrong while getting '+name)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });
}

function setVehicleProduct() {
    let engine_id = $('#vehicle_engines_id').val()
    let str_products   = $('#data_products').val()
    let products = JSON.parse(str_products)
    let searchResult = document.getElementById('battery-search-result')
    let target = document.getElementById('bci-recomendado')
    let resultModels = document.getElementById('search-result-models')
    const result = products.find(
        product => product.engine_id === Number(engine_id)
    );
    let bcis_array = result?.bcis_array
    let bcis = result?.bcis
    let models = result?.models
    let modelsHtml = ''
    searchResult.style.display = "block";
    target.innerHTML = isNullOrUndef(result) || isNullOrUndef(bcis) ? 'No se encontraron resultados' : 'Nuestras baterías para BCI: ' + bcis
    resultModels.innerHTML = ''
    // cgreent('setVehicleProduct')
    // cgreen(result, 'result')
    // cgreen(bcis, 'bcis')
    // cgreen(isNullOrUndef(result), 'isNullOrUndef(result)')
    if(models && models[0]) {
        models.forEach(m => {
            let model = '<div class="col-lg-3 col-md-6">\n' +
            '          <div class="product-block-one week-deal-one">\n' +
            '            <div class="ribon fs_13">BCI '+m.bci+'</div>\n' +
            '            <div class="product-block-one-image">\n' +
            '              <div class="image">\n' +
            '                <img class="text-centered" style="width: 250px; height: 188px;" src="'+m.medium_photo_url+'">\n' +
            '              </div>\n' +
            '            </div>\n' +
            '            <div class="product-block-one-cintent">\n' +
            '              <h4 class="fs_15"><a href="#">'+ m.description +' </a></h4>\n' +
            '              <div class="rating">\n' +
            '                <i class="fas fa-medal"></i>\n' +
            '                <span>Garantía: '+m.warranty_months+' </span>\n' +
            '              </div>\n' +
            '              <div class="price-container">\n' +
            '                <div class="price fs_15 fw_medium">'+m.price+'<span>'+m.price_iva+'</span></div>\n' +
            '              </div>\n' +
            '            </div>\n' +
            '          </div>\n' +
            '        </div>\n'
            modelsHtml = modelsHtml + model
        })
        resultModels.innerHTML = modelsHtml
    } else if(!isNullOrUndef(bcis) && 'undefined' !== bcis && 'null' !== bcis  && 'Undefined or Null' !== bcis ) {
        // credt(bcis, 'bcis')
        target.innerHTML = 'No se encontraron resultados para BCI: ' + bcis
    }
}

function setWarranty() {
    let checked = $('#warranty_fleet') && $('#warranty_fleet').prop('checked')
    if(checked) {
        $('#warranty_warranty').val($('#model_warranty_fleet').val())
    } else {
        $('#warranty_warranty').val($('#model_warranty').val())
    }
}

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}
const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_years_id','vehicle_makes_id','vehicle_models_id','vehicle_engines_id']
function setupLanding() {
    // var $select2Element = $('.select2');
    $('.select2').select2({
        // tags: true,
        tokenSeparators: [',', ' '],
        // allowClear: true,
        theme: "classic",
        width: 'resolve'
    });

    // // // Add the 'nice-select' class to the Select2 container
    // $select2Element.data('select2').$container.addClass('nice-select');

    const form = document.getElementById("home-landing");
    if (form) {
        console.log('warranties turbolinks loaded.')
        // Clear previous listeners
        // clearSelect2('battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id')
        // clearSelect2('vehicle_years_id','vehicle_makes_id','vehicle_models_id','vehicle_engines_id')
        clearSelect2(...select2Ids)
        // Init search select inputs
        checkVehicleSearch(true)
        // Attach new listeners
        let vehicle_years = document.getElementById('vehicle_years_id')
        console.log(vehicle_years, 'vehicle_years')
        $(document)
            .on('select2:select', '#vehicle_years_id', getVehicleMakes)
            .on('select2:select', '#vehicle_makes_id', getVehicleModels)
            .on('select2:select', '#vehicle_models_id', getVehicleEngines)
            .on('select2:select', '#vehicle_engines_id', setVehicleProduct)
            .on('change', '#warranty_phone_number', getCustomer)
            .on('change', '#warranty_fleet', setWarranty)
    }
}

function getCustomer()  {
    let phone_number = $('#warranty_phone_number').val()
    if (!phone_number || phone_number.length < 10) {
        return $.Deferred().resolve().promise();
    }
    $('#warranty_first_name').val()
    $('#warranty_last_name').val()
    $('#warranty_email').val()
    let path = '/search/customer/' + $('#warranty_phone_number').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                if (data.customer) {
                    $('#warranty_phone_number').val(phone_number)
                    $('#warranty_first_name').val(data.customer.first_name)
                    $('#warranty_last_name').val(data.customer.last_name)
                    $('#warranty_email').val(data.customer.email)
                }
            } else {
                console.error('Something goes wrong while getting '+phone_number)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}

function destroyLanding() {
    const form = document.getElementById("home-landing");
    if (form) {
        console.log("Cleanup home-landing...")
        document.removeEventListener("turbolinks:load", setupLanding);
        document.removeEventListener('turbolinks:before-cache', destroyLanding)

        $(document)
            .off('select2:select', '#vehicle_years_id', getVehicleMakes)
            .off('select2:select', '#vehicle_makes_id', getVehicleModels)
            .off('select2:select', '#vehicle_models_id', getVehicleEngines)
            .off('select2:select', '#vehicle_engines_id', setVehicleProduct)
            .off('change', '#warranty_phone_number', getCustomer)

        $('.selectpicker').each(function() {
            console.log('woop')
            if ($(this).data('select2')) {
                $(this).select2('destroy');
            }
        });
    }
}
document.addEventListener("turbolinks:load", setupLanding);
// document.addEventListener('turbolinks:before-cache', destroyLanding);
window.addEventListener('beforeunload', (event) => {
    destroyLanding();
});

window.checkVehicleSearch = checkVehicleSearch;
window.getVehicleMakes = getVehicleMakes;
window.getVehicleModels = getVehicleModels;
window.getVehicleEngines = getVehicleEngines;
window.setVehicleProduct = setVehicleProduct;
